import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { calculateRem } from '@uie/javascript-style-helpers';
import { breakpoints } from '@vzrf/react-theme-helpers';

import FilterChipControls from './FilterChipControls';

const ResultsFilterStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border: ${calculateRem(1)} solid ${({ theme }) => theme.coolGray3};
  height: ${props => calculateRem(props.filterStyles.height)};
  
  @media screen and (min-width: ${breakpoints.sm}) {
    flex-direction: row;
    align-items: center;
  }
`;

class ResultsFilter extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    filters: PropTypes.arrayOf(PropTypes.object).isRequired,
    filterClick: PropTypes.func,
    filterChipStyles: PropTypes.object,
    filterStyles: PropTypes.object,
    handleChipClick: PropTypes.func,
    leftScrollStyles: PropTypes.object,
    rightScrollStyles: PropTypes.object,
    scrollDuration: PropTypes.number
  };

  static defaultProps = {
    chipAddedFadeInDuration: null,
    className: null,
    closeChipLabel: undefined,
    filters: [],
    filterClick: undefined,
    filterChipStyles: {},
    filterStyles: {},
    handleChipClick: undefined,
    leftScrollStyles: {},
    rightScrollStyles: {},
    scrollDuration: null
  };

  constructor(props) {
    super(props);

    this.resetScroll = false;
    this.defaultHeight = '45px'; // <- must stay in px for IE11 to work

    this.state = {
      filterClick: props.filterClick
        ? props.filterClick
        : this.warnMissingFilterCallback,
      filters: this.props.filters,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.filters.length !== this.props.filters.length) {
      this.resetScroll = true;

      const newFilters = this.checkChipAdded();

      this.setState({
        filters: newFilters,
      });
    }
  }

  checkChipAdded = () => {
    const filterLookup = {};
    this.state.filters.forEach(filter => {
      filterLookup[filter.title] = filter;
    });

    const newFilters = [];
    this.props.filters.forEach(filter => {
      if (typeof filterLookup[filter.title] === 'undefined') {
        filter.chipAdded = true;
        filter.chipAddedClassName = 'filterChipFadeIn';
      } else {
        delete filter.chipAdded;
        delete filter.chipAddedClassName;
      }
      newFilters.push(filter);
    });

    return newFilters;
  };

  warnMissingFilterCallback = () => {
    console.error('ResultsFilter: Warning: required filterClick prop missing.');
  };

  render() {
    // Check for ResultsFilter height Overrides, which has to be handled separately
    const styles = {
      height: this.defaultHeight,
      ...this.props.filterStyles,
    };

    // Setting a specific height on ResultsFilter clips flex columns in Mobile mode
    // All the other Styles can be passed directly to ResultsFilter
    const stylesNoHeight = {
      ...this.props.filterStyles,
    };
    delete stylesNoHeight['height'];

    // Need to do a Reset only once, so get resetScroll and then clear it
    const resetScroll = this.resetScroll;
    this.resetScroll = false;

    return (
      <ResultsFilterStyled
        role='tablist'
        data-testid="results-filter"
        className={this.props.className}
        filterStyles={styles}
        style={stylesNoHeight}
        // tabIndex="0"
        onKeyDown={this.props.selectSearchTab}
        aria-label="Channel Category"
      >
        <FilterChipControls
          chipAddedFadeInDuration={this.props.chipAddedFadeInDuration}
          closeChipLabel={this.props.closeChipLabel}
          filters={this.state.filters}
          filterChipStyles={this.props.filterChipStyles}
          filterStyles={styles}
          handleChipClick={this.props.handleChipClick}
          leftScrollStyles={this.props.leftScrollStyles}
          resetScroll={resetScroll}
          rightScrollStyles={this.props.rightScrollStyles}
          scrollDuration={this.props.scrollDuration}
        />
      </ResultsFilterStyled>
    );
  }
}

export default ResultsFilter;
